<template>
  <div class="userAgreement">
    <!--用户服务协议:5 隐私政策:6  退款中心:7 自审制度：9  用户纠纷处理：10   未成年保护制度：11-->
    <user-service v-if='actType == 0 && actMiniTtype == 5'  style="height: 760px; overflow-y: auto;"></user-service>
    <user-privacy v-if='actType == 0 && actMiniTtype == 6'  style="height: 760px; overflow-y: auto;"></user-privacy>
    <user-refund v-if='actType == 0 && actMiniTtype == 7'  style="height: 760px; overflow-y: auto;"></user-refund>
    <user-audit-aystem v-if='actType == 0 && actMiniTtype == 9'  style="height: 760px; overflow-y: auto;"></user-audit-aystem>
    <user-disputes v-if='actType == 0 && actMiniTtype == 10'  style="height: 760px; overflow-y: auto;"></user-disputes>
    <user-minors v-if='actType == 0 && actMiniTtype == 11'  style="height: 760px; overflow-y: auto;"></user-minors>
  </div>
</template>
  
<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from 'vue-router'
import userService from '../../components/userAgreement/userService.vue'
import userRefund from '../../components/userAgreement/userRefund.vue'
import userPrivacy from '../../components/userAgreement/userPrivacy.vue'
import userMinors from '../../components/userAgreement/userMinors.vue'
import userDisputes from '../../components/userAgreement/userDisputes.vue'
import userAuditAystem from '../../components/userAgreement/userAuditAystem.vue'
let route = useRoute()
let actType = ref(route.query.id)
let actMiniTtype = ref(route.query.miniID)
watch(() => route.query,
  (val) => {
    actType.value = val.id;
    actMiniTtype.value=val.miniID
  })
</script>
  
<style lang="scss" scoped>
.userAgreement {
  padding: 30px 40px 30px 60px;
  box-sizing: border-box;
  // background-color: aquamarine;
}
</style>
  